import axios from 'axios'
import actionTypes from '../../constants/action-types'

export default {
    async [actionTypes.ENVIO_CUPOM.REGISTRAR_INTENCAO_COMPRA_ORGANIZACAO]({state, commit}, organizacaoId) {
        const {data} = await axios.post(`api/envio-cupom/organizacao/${organizacaoId}/registrar?motivo=INTENCAO_COMPRA`)
        return data
    },

    async [actionTypes.ENVIO_CUPOM.REGISTRAR_DOCUMENTOS_ESGOTADOS_ORGANIZACAO]({state, commit}, organizacaoId) {
        const {data} = await axios.post(`api/envio-cupom/organizacao/${organizacaoId}/registrar?motivo=DOCUMENTOS_ESGOTADOS`)
        return data
    },
}